import dayjs from 'dayjs';

import {
  loadAppointmentsRequests,
  loadTodaysAppointments,
} from 'actions/appointments';
import { getAppointments } from 'actions/inventory';
import { getDayFromDate, prettifyHour } from 'util';
import { hoursOptions } from 'util/constants';

export const disableDropdown = (index, suggestions, hours) => {
  // Grab selected reschedule day.
  const selectedDOW = suggestions?.[index]?.date;
  if (!selectedDOW) return false;

  // 02/02/2023 => Monday. This is the format returned by API in location::hours object
  const selectedDOWFormatted = dayjs(selectedDOW).format('dddd');

  // Grab the start and end business hours for that day. If business is closed, return no hours.
  const dayBusinessHours = hours.filter(
    (el) => el.dow.value === selectedDOWFormatted
  )[0]?.time;
  return !dayBusinessHours;
};

export const isBusinessOpen = (index, suggestions, hours) => {
  // Grab selected reschedule day.
  const selectedDOW = suggestions?.[index]?.date;
  if (!selectedDOW) return 'Start time';

  // 02/02/2023 => Monday. This is the format returned by API in location::hours object
  const selectedDOWFormatted = dayjs(selectedDOW).format('dddd');

  // Grab the start and end business hours for that day. If business is closed, return no hours.
  const dayBusinessHours = hours.filter(
    (el) => el.dow.value === selectedDOWFormatted
  )[0]?.time;
  return !dayBusinessHours ? 'Business closed' : 'Start time';
};

export const availableHoursOptions = (index, suggestions, hours) => {
  const allHours = hoursOptions.filter((el) => el.value !== 'Closed');

  // Grab selected reschedule day.
  // If there isn't any (user starts by choosing hours) return all hours
  const selectedDOW = suggestions?.[index]?.date;
  if (!selectedDOW) return allHours;

  // 02/02/2023 => Monday. This is the format returned by API in location::hours object
  const selectedDOWFormatted = dayjs(selectedDOW).format('dddd');

  // Grab the start and end business hours for that day. If business is closed, return no hours.
  const dayBusinessHours = hours.filter(
    (el) => el.dow.value === selectedDOWFormatted
  )[0]?.time;
  if (!dayBusinessHours) return [];

  const startIndex = hoursOptions.findIndex(
    (el) => el.valueFormatted === dayBusinessHours.start
  );
  const endIndex = hoursOptions.findIndex(
    (el) => el.valueFormatted === dayBusinessHours.end
  );

  return hoursOptions.slice(startIndex, endIndex);
};

export const modalsInfo = (appointment) => ({
  Cancel: {
    appointment,
    title: 'Confirm cancellation',
    description: `Are you sure you want to cancel ${
      appointment.animal.name
    }’s ${appointment.service.name} appointment on ${getDayFromDate(
      appointment.dateStart
    )} at ${prettifyHour(appointment.dateStart, true)}?`,
    status: 'cancel',
  },
  Decline: {
    appointment,
    title: 'Confirm decline',
    description: `Are you sure you want to decline ${
      appointment.animal.name
    }’s ${appointment.service.name} appointment on ${getDayFromDate(
      appointment.dateStart
    )} at ${prettifyHour(appointment.dateStart, true)}?`,
    status: 'decline',
  },
  Reschedule: {
    appointment,
    title: 'Reschedule',
    description:
      'Suggest up to 5 available times for the client to select from',
  },
});

export const trackAppointmentAction = (event) => {
  let eventName;
  // These refer to the action of clicking dropdown item
  if (event === 'Accepted') eventName = 'Reschedule';
  if (event === 'Pending') eventName = 'Suggest new times';
  if (event === 'No show') eventName = 'Client no show';
  if (event === 'Cancel') eventName = 'Cancel appointment';
  if (event === 'Decline') eventName = 'Decline appointment';
  // These refer to the actual action request being successful
  if (event === 'no-show') eventName = 'Confirm no show';
  if (event === 'cancel') eventName = 'Confirm cancel';
  if (event === 'decline') eventName = 'Confirm decline';
};

export const refreshAppointments = ({ location, query, dispatch, auid }) => {
  const isPetProfile = location.pathname.includes('pet-profile');
  const isTodayView = location.pathname.includes('today');
  const isCalendarView = location.pathname.includes('appointments');

  if (isPetProfile) dispatch(loadAppointmentsRequests(auid));
  if (isTodayView) dispatch(loadTodaysAppointments());
  if (isCalendarView)
    dispatch(
      getAppointments({
        dateStart: query.get('start'),
        dateEnd: query.get('end'),
      })
    );
};
